import { Column } from 'react-table';

import { LifeSkillsMonitoring } from 'api';
import { formatDate } from 'utils';
import { CheckIcon, ViewDetailsButton } from 'components';
import { getLifeSkillsMonitoringNonStandardReasonName } from 'const/life-skills-monitoring-non-standard-reason/lifeSkillsMonitoringNonStandardReasonHelpers';
import { getLifeSkillsLevelName } from 'const/life-skills-level/lifeSkillsLevelHelpers';
import { getLifeSkillsMonitoringStageName } from 'const/life-skills-monitoring-stage/lifeSkillsMonitoringStageHelpers';
import { getLifeSkillsMonitoringResultName } from 'const/life-skills-monitoring-result/lifeSkillsMonitoringResultHelpers';

export const columns: Column<LifeSkillsMonitoring>[] = [
  {
    Header: 'Date of Certification',
    accessor: 'certificationDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Date of monitoring',
    accessor: 'monitoringDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Level',
    accessor: 'lifeSkillsLevel',
    width: 'auto',
    Cell: ({ value }) => <>{getLifeSkillsLevelName(value)}</>,
  },
  {
    Header: 'Monitoring result',
    accessor: 'monitoringResult',
    width: 'auto',
    Cell: ({ value }) => <>{getLifeSkillsMonitoringResultName(value)}</>,
  },
  {
    Header: 'Monitoring stage',
    accessor: 'monitoringStage',
    width: 'auto',
    Cell: ({ value }) => <>{value ? getLifeSkillsMonitoringStageName(value) : ''}</>,
  },
  {
    Header: 'IDP',
    accessor: 'isFromIdp',
    width: '50px',
    Cell: CheckIcon,
  },
  {
    Header: 'Type of monitoring',
    accessor: 'nonStandardReason',
    width: 'auto',
    Cell: ({ value }) => <>{value ? getLifeSkillsMonitoringNonStandardReasonName(value) : ''}</>,
  },
  {
    Header: 'Follow Up completed',
    accessor: 'followUpId',
    width: '75px',
    Cell: CheckIcon,
  },
  {
    Header: 'Details',
    accessor: 'id',
    width: '50px',
    Cell: ({ value }) => <ViewDetailsButton to={value} />,
  },
];
